



























































































































import CustomTimepicker from "@/components/Common/Date/CustomTimepicker.vue";
import DateSelect from "@/components/Common/Date/DateSelect.vue";
import { FinanceOutTransactionType } from "@core/store/types/webmaster/finances/modal/enum/financeOutTransactionType";
import { FinanceTypeEnum } from "@core/store/types/webmaster/finances/modal/enum/financeTypeEnum";
import { FinanceDayEnum } from "@core/store/types/webmaster/finances/modal/enum/financeDayEnum";
import { RequisitesListItem } from "@core/store/types/admin/lists/RequisitesListState";
import { actionWithToast } from "@/helpers/actionWithToast";
import { computed, ref, watch } from "@vue/composition-api";
import { formatCurrency } from "@/core/src/filters";
import i18n from "@core/plugins/i18n";
import { storeToRefs } from "pinia";
import LTaglist from "@/components/Common/LTaglist.vue";
import { useAutoPayments } from "@/stores/webmaster/finance/modal/autoPaymentsStore";
import LabelWithAnnotation from "@/components/Common/Tooltip/LabelWithAnnotation.vue";
import { defineExpose } from "@vue/runtime-dom";
import { useRequisiteStore } from "@/stores/webmaster/finance/modal/requisiteStore";
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const store = useAutoPayments();
  const {
    options
  } = storeToRefs(store);
  const requisiteStore = useRequisiteStore();
  const {
    data: requisites
  } = storeToRefs(requisiteStore);
  const isReadySending = ref(false);
  const types = computed(() => {
    return [{
      value: FinanceTypeEnum.DAILY,
      label: i18n.t("webmaster.finances.autoPaymentModal.tabs.daily")
    }, {
      value: FinanceTypeEnum.WEEKLY,
      label: i18n.t("webmaster.finances.autoPaymentModal.tabs.weekly")
    }, {
      value: FinanceTypeEnum.DATE,
      label: i18n.t("webmaster.finances.autoPaymentModal.tabs.selectDate")
    }];
  });
  // @ts-ignore
  const daysOfWeek = computed(() => [...i18n.t("common.days.short").slice(1), i18n.t("common.days.short")[0]]);
  const hasOutTransactionSum = computed(() => options.value.outTransactionType === FinanceOutTransactionType.SUM);
  const hasOutTransactionTime = computed(() => options.value.outTransactionType === FinanceOutTransactionType.TIME);
  const validationData = computed(() => ({
    ...(options.value.type === FinanceTypeEnum.DATE && {
      datepickerDates: !options.value.datepickerDates && options.value.datepickerDates?.length !== 0
    }),
    options: !options.value.time && options.value.time !== 0,
    ...(options.value.type === FinanceTypeEnum.WEEKLY && {
      daysOfWeek: options.value.daysOfWeek?.length === 0
    })
  }));
  const isValid = computed(() => options.value.outTransactionType === FinanceOutTransactionType.SUM || Object.values(validationData.value).every(v => !v));
  const requisite = computed(() => requisites.value.items?.find((el: RequisitesListItem) => el.id === options.value.requisiteId));
  const currentCurrency = computed(() => requisite.value?.paymentSystem.currency);
  const minimalPayout = computed(() => requisite.value?.paymentSystem?.minimalPayout);
  const watchParams = computed(() => JSON.stringify({
    minimalPayout: minimalPayout.value,
    outTransactionType: options.value.outTransactionType
  }));
  const validationAmount = computed(() => {
    // @ts-ignore
    if (options.value.sum === "") {
      return i18n.t("webmaster.finances.financeOrder.messages.errorAmount");
    } else if (options.value.sum !== null && options.value.sum < minimalPayout.value) {
      return i18n.t("webmaster.finances.financeOrder.messages.errorMinAmount", {
        value: formatCurrency(minimalPayout.value, currentCurrency.value)
      });
    }
    return "";
  });
  const getAutoPaymentsType = computed(() => {
    return [{
      id: FinanceOutTransactionType.SUM,
      name: i18n.t("webmaster.finances.autoPaymentModal.typePayments.bySum")
    }, {
      id: FinanceOutTransactionType.TIME,
      name: i18n.t("webmaster.finances.autoPaymentModal.typePayments.byTime")
    }];
  });
  function changeDaysOfWeek(key: FinanceDayEnum): void {
    options.value.daysOfWeek = hasDayByArray(key) ? options.value.daysOfWeek.filter((el: FinanceDayEnum) => el !== key) : [...options.value.daysOfWeek, key];
  }
  function hasDayByArray(value: FinanceDayEnum): boolean {
    return options.value.daysOfWeek?.includes(value);
  }
  function resetData() {
    if (!options.value.isEdit) {
      options.value.datepickerDates = null;
      options.value.time = 840;
      options.value.daysOfWeek = [FinanceDayEnum.TUESDAY, FinanceDayEnum.FRIDAY];
    }
    options.value.sum = null;
    isReadySending.value = false;
  }
  async function submit() {
    isReadySending.value = true;
    if (isValid.value) {
      await actionWithToast(store.ACTION_AUTO_OUT_TRANSACTION(), `webmaster.finances.autoPaymentModal.messages.${options.value.isEdit ? "editAutoPayment" : "addAutoPayment"}`);
    }
  }
  watch((): string => watchParams.value, () => {
    if (!options.value.isEdit) {
      if (hasOutTransactionSum.value) {
        options.value.sum = minimalPayout.value;
      } else {
        options.value.sum = null;
      }
    }
  });
  return Object.assign({
    FinanceDayEnum,
    i18n,
    options,
    types,
    daysOfWeek,
    hasOutTransactionSum,
    hasOutTransactionTime,
    validationData,
    currentCurrency,
    minimalPayout,
    validationAmount,
    getAutoPaymentsType,
    changeDaysOfWeek,
    hasDayByArray,
    resetData
  }, {
    submit,
    isValid
  });
};
__sfc_main.components = Object.assign({
  LabelWithAnnotation,
  LTaglist,
  DateSelect,
  CustomTimepicker
}, __sfc_main.components);
export default __sfc_main;
